import React, { useRef, useState } from 'react';
import "../../../Css/App/OfferPage.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import offer01 from "../../../Images/home_cat_overlay_02.png";
import { Link } from 'react-router-dom';
const OfferPage = (() => {
    return (
        <>
            <section className="home-service-offer-price-section">
                <Swiper
                    spaceBetween={30}
                    centeredSlides={true}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    modules={[Autoplay, Pagination, Navigation]}
                    className="mySwiper"
                >
                    <SwiperSlide>
                        <div className='home-service-offer-price-card-main-con'>
                            <div className='home-service-offer-price-card-details-main-con'>
                                <div className='row'>
                                    <div className='col-6'>
                                        <div className='home-service-offer-price-card-details-info'>
                                            <div className='home-service-offer-price-card-details-info-con'>
                                                <h3>Style Made For You</h3>
                                                <h4>Transform Yourself, Feel Renewed</h4>
                                                <h5>Glamour That Lasts</h5>
                                                <div className='home-service-offer-price-card-details-info-btn-main-con'>
                                                    <Link to="/service">
                                                        <button>
                                                            View More
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='home-service-offer-price-card-details-image-main-con'>
                                            <div className='home-service-offer-price-card-details-image-con'>
                                                <img src={offer01} alt='offer01' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>

            </section>
        </>
    )
});

export default OfferPage;